import { ClientFileUpdateKey } from './UserClients.types';

export const FILE_UPDATE_API_KEYS: Record<ClientFileUpdateKey, string> = {
  mailPlanTemplate: 'update_businessUnit_mailplan',
  emailActivity: 'upload_business_unit_statistic',
};
